export const PAGE_PATH = {
    LOGIN: "/Login",
    LOG_OUT: "/Logout",
    PAGE_NOT_FOUND: "/"
};